import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  viewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fromEvent, of } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  finalize,
  map,
  switchMap,
} from 'rxjs/operators';
import { CustomPlacesByOrganizationDto } from 'src/app/core/api/models';

import { PublicPlaceService, ZonesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { TransferDataService } from 'src/app/core/services/transfer-data.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { PublicPlaceSubCategorySelectSearchComponent } from 'src/app/shared/components/select-search/public-places-sub-category-select-search.component';
import { ZonesSelectSearchComponent } from 'src/app/shared/components/select-search/zones-select-search.component';
import { SmartSendMapControlComponent } from 'src/app/shared/components/smart-send-map-control/smart-send-map-control.component';

@Component({
    selector: 'send-smart-sms-advance-search',
    templateUrl: './send-smart-sms-advance-search.component.html',
    styleUrls: ['./send-smart-sms-advance-search.scss'],
    standalone: false
})
export class SendSmartSmsAdvanceSearchlComponent
  extends BaseFormPageComponent
  implements OnInit
{
  readonly searchInput = viewChild<ElementRef>('searchInput');
  readonly citySelectSearch = viewChild<ZonesSelectSearchComponent>('citySelectSearch');
  readonly categorySelectSearch = viewChild<PublicPlaceSubCategorySelectSearchComponent>('categorySelectSearch');
  readonly Map = viewChild<SmartSendMapControlComponent>('Map');

  stateId: number = -1;
  cityId: number = -1;
  categoryId: number = -1;

  suggestedListPublic: any[] = [];
  suggestedListPersonal: any[];
  selectedListPersonal = [];
  selectedListPersonalIds = [];
  //todo change type
  selectedListPublic: Array<any> = [];
  searchText: string = '';
  loadingPublic: boolean = false;
  isShowEmptyItems: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<SendSmartSmsAdvanceSearchlComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public zoneService: ZonesService,
    private publicPlaceService: PublicPlaceService
  ) {
    super();
  }

  ngOnInit() {
    this.selectedListPersonal = TransferDataService.selectedListPersonal;
    this.selectedListPublic = TransferDataService.selectedListPublic;
    TransferDataService.removedListPublic = [];
    TransferDataService.removedListPersonal = [];

    this.initForm();
  }

  initForm(): void {
    this.form = new FormGroup({
      categoryControl: new FormControl(''),
      stateControl: new FormControl('', Validators.required),
      cityControl: new FormControl('', Validators.required),
    });
  }
  ngAfterViewInit() {
    let loading: boolean = false;
    fromEvent(this.searchInput()?.nativeElement, 'input')
      .pipe(
        map((event) => event as KeyboardEvent),
        map((event) => (event.target as HTMLInputElement).value),
        map((value) => value.trim()),
        map((value) => (this.searchText = value)),
        distinctUntilChanged(),
        debounceTime(1000),
        switchMap((searchText) => this.search())
      )
      ?.pipe(
        finalize(() => {
          this.loadingPublic = false;
        })
      )
      .subscribe((items: any) => {
        if (items?.data.length > 0) {
          this.isShowEmptyItems = false;
          items?.data.forEach((item) => {
            if (!this.selectedListPublic.some((a) => a.id == item.id))
              this.suggestedListPublic.push(item);
          });
        } else this.isShowEmptyItems = true;
        this.loadingPublic = false;
      });
  }

  search(): any {
    // TODO torbatian
    if (!this.searchText.trim()) return of([]);

    if (this.cityId && this.stateId) {
      this.loadingPublic = true;
      this.suggestedListPublic = [];
      return this.publicPlaceService.publicPlaceGetPublicPlacesByFilter({
        body: {
          categoryId: this.categoryId,
          cityId: this.cityId,
          searchText: this.searchText,
          stateId: this.stateId,
        },
      });
    }
  }

  onStateChange() {
    this.search()
      ?.pipe(
        finalize(() => {
          this.loadingPublic = false;
        })
      )
      ?.subscribe((items) => {
        if (items?.data.length > 0) {
          this.isShowEmptyItems = false;
          items?.data.forEach((item) => {
            if (!this.selectedListPublic.some((a) => a.id == item.id))
              this.suggestedListPublic.push(item);
          });
        } else this.isShowEmptyItems = true;
        this.loadingPublic = false;
      });
  }

  onCityChange($event) {
    this.cityId = $event;
    this.zoneService
      .zonesGetZoneCoordinates({ ZoneId: this.cityId })
      .subscribe((result) => {
        try {
          this.search()
            ?.pipe(
              finalize(() => {
                this.loadingPublic = false;
              })
            )
            .subscribe((items) => {
              if (items?.data?.length > 0) {
                this.isShowEmptyItems = false;
                items?.data.forEach((item) => {
                  if (!this.selectedListPublic.some((a) => a.id == item.id))
                    this.suggestedListPublic.push(item);
                });
              } else this.isShowEmptyItems = true;
              this.loadingPublic = false;
            });
          let center = JSON.parse(result?.data) as mapboxgl.LngLatLike;
          this.Map()?.SetCenter(center);
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
        }
      });
  }

  onCategoryChange($event) {
    this.categoryId = $event;
    this.search()
      ?.pipe(
        finalize(() => {
          this.loadingPublic = false;
        })
      )
      .subscribe((items) => {
        items?.data.forEach((item) => {
          if (!this.selectedListPublic.some((a) => a.id == item.id)) {
            this.suggestedListPublic.push(item);
          }
        });
        this.loadingPublic = false;
      });
  }

  onSelectionPublic(event) {
    if (event.checked) {
      if (!this.selectedListPublic.find((a) => a.id == event.source.value))
        this.selectedListPublic.push(
          this.suggestedListPublic.find((a) => a.id == event.source.value)
        );
      TransferDataService.selectedListPublic = this.selectedListPublic;
    } else {
      let index = this.selectedListPublic.findIndex(
        (a) => a.id == event.source.value
      );
      this.selectedListPublic.splice(index, 1);
      TransferDataService.selectedListPublic = this.selectedListPublic;
    }
  }

  onSelectionPersonal(event: any[]) {
    // this.selectedListPersonal = [];
    this.selectedListPersonalIds = [];
    event.forEach((item) => {
      let exist = this.selectedListPersonal.find((a) => a.id == item.id);
      if (!exist) {
        this.selectedListPersonal.push(item);
        TransferDataService.selectedListPersonal = this.selectedListPersonal;
      }
      let existId = this.selectedListPersonal.find((a) => a == item.id);
      if (!existId) {
        this.selectedListPersonalIds.push(item.id);
      }
    });
  }

  onRemovePublic(id: number) {
    const matChecobxElement = document.getElementById('chb-' + id);
    if (matChecobxElement != null) {
      let checkboxInputElemtn = matChecobxElement.querySelector('input');
      (checkboxInputElemtn as HTMLInputElement).click();
    } else {
      let index = this.selectedListPublic.findIndex((a) => a.id == id);
      let deletedItem = this.selectedListPublic.splice(index, 1);
      TransferDataService.selectedListPublic = this.selectedListPublic;
      TransferDataService.removedListPublic.push(deletedItem[0]);
    }
  }

  onRemovePersonal(id: string) {
    let index = this.selectedListPersonal.findIndex((a) => a.id == id);
    let deletedItem = this.selectedListPersonal.splice(index, 1);
    TransferDataService.selectedListPersonal = this.selectedListPersonal;
    TransferDataService.removedListPersonal.push(deletedItem[0]);
    let indexIds = this.selectedListPersonalIds.findIndex((a) => a == id);
    this.selectedListPersonalIds.splice(indexIds, 1);
  }

  onClose() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.selectedListPublic = this.selectedListPublic.map((place) => {
      return { ...place, coordinates: [place.coordinates] };
    });
    let finalSelectedListPublic: CustomPlacesByOrganizationDto[] = [];
    finalSelectedListPublic = this.selectedListPublic.map((item) => {
      return {
        title: item.title,
        polygons: [{ title: item.title, coordinates: item.coordinates[0] }],
      };
    });

    const places = finalSelectedListPublic.concat(this.selectedListPersonal);

    this.dialogRef.close(places);
  }
}
